import { DateType } from 'api/models';
import { dateSorter } from '../sorters';

type HasStartDate = { startDate?: DateType | null };
export const byStartDate = (a?: HasStartDate, b?: HasStartDate): number =>
  dateSorter(a?.startDate, b?.startDate);
